module.exports = __webpack_public_path__ + "static/bootstrap-flex-align-512970bc902f77bb037e4feb1a3298d8.png";